import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useGetTemplatesQuery } from '@/state/slices/reports';
import type { Template } from '@/models/template';
import HeartLoader from '@/shared/ui/HeartLoader';
import styles from './TemplateList.module.css';

const { Text } = Typography;

export function TemplateList() {
  const { data, isLoading } = useGetTemplatesQuery();
  const templates = data?.results ?? [];

  const columns: ColumnsType<Template> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string) => <Text strong>{name}</Text>,
    },
    {
      title: 'Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 200,
      render: (date: string) =>
        new Date(date).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
    },
  ];

  return (
    <div className={styles.container}>
      <Table
        rowKey="uuid"
        columns={columns}
        dataSource={templates}
        loading={{
          spinning: isLoading,
          indicator: <HeartLoader size="sm" />,
        }}
        pagination={false}
        locale={{ emptyText: 'No templates found' }}
      />
    </div>
  );
}
